<div class="coverages-outer-container" [formGroup]="form">
  @if (showPremium) {
    <div class="premium-section bolt-justify-content-center">
      <h2 class="premium-monthly">
        {{
        priceSummaryDisplayProduct.installmentPrice
        }}<span class="per-month"><strong>{{
        priceSummaryDisplayProduct.installmentFrequency
      }}</strong></span>
    </h2>
  </div>
  <div class="bolt-row bolt-justify-content-center">
    <h3 class="premium-total">
      {{ priceSummaryDisplayProduct.totalPrice }}
    </h3>
    <span class="per-month-monthly">
      {{ priceSummaryDisplayProduct.termLength }}
    </span>
  </div>
  <hr />
}

<div class="bolt-row effective-container">
  <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
    @if (!showDatePicker) {
      <div
        class="update-effectiveDate-container"
        (click)="showDatePicker = true"
        >
        <a id="acdc-Effective-date-{{ product.type }}"
          >Effective date {{ form.value.effectiveDate }}</a
          >
          <bolt-icon
            name="pencil"
            [attr.id]="'acdc-pencil-' + product.type"
            color="mediumBlue"
            [attr.size]="maxSizeMini ? 'sm' : 'md'"
            class="icon-top-padding mt-05"
          ></bolt-icon>
        </div>
      }
      @if (showDatePicker) {
        <nwx-datepicker-input
          controlId="effectiveDate"
          id="acdc-effective-date"
          label="Effective date"
          controlName="effectiveDate"
          placeholder="MM/DD/YYYY"
          [minDate]="policyDateOptions?.minDate || null"
          [maxDate]="policyDateOptions?.maxDate || null"
          [disabled]="(updateInProgress$ | async) || false"
          [relevantProduct]="product.type"
          [quoteCreateDate]="product.quoteCreateDate"
          [bumpHeaderMargin]="true"
        ></nwx-datepicker-input>
      }
    </div>
    <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
      <div
        class="remove-policy-container"
        (click)="promptToRemovePolicy($event)"
        >
        <a href="#">Save submission for later</a>
        <bolt-icon
          name="folder"
          [attr.id]="'acdc-folder'"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
      <div
        class="remove-policy-container"
        (click)="promptToWithdrawPolicy($event)"
        >
        <a href="#">Delete submission</a>
        <bolt-icon
          name="trash"
          [attr.id]="'acdc-trash'"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
    </div>
  </div>
  <hr />

  @if (showPremium ) {
    <div class="info-row heading">
      <div class="bolt-row">
        <div class="bolt-col unpad-row">
          <strong class="section-header">Member details</strong>
        </div>
      </div>
    </div>
    <div class="bolt-row">
      <div class="bolt-col no-left-pad">
        <b>Named Insured</b>
        @for (person of policyHoldersForDisplay; track person.name; let isLast = $last) {
          <span>
            {{ person.name }} <b>{{ person.role }}</b
            >{{ isLast ? '' : ', ' }}
          </span>
        }
        <a
          class="link"
          id="edit-pni-sni-PersonalAuto"
          href="javascript:0"
          (click)="openNamedInsuredModal($event)"
          >
          <bolt-icon
            id="edit-pni-sni-PersonalAuto-icon"
            title="Update named insureds"
            name="pencil"
            color="mediumBlue"
            size="sm"
          ></bolt-icon>
        </a>
      </div>
    </div>
    <!--TODO Additional Interest-->
    <div class="bolt-row">
      <div class="bolt-col unpad-row">
        <b>Drivers</b>
        @for (person of driversForDisplay; track person.name; let isLast = $last) {
          <span>
            {{ person.name }}{{ isLast ? '' : ', ' }}
          </span>
        }
        <bolt-contextual-help>
          <p>
            Modify status of driver, excluded, and non-drivers by editing the
            <a href="#" (click)="onEditDrivers($event)">Members page</a>.
          </p>
        </bolt-contextual-help>
      </div>
    </div>
    <hr />
    <div class="info-row heading">
      <div class="bolt-row bolt-justify-content-between">
        <div class="bolt-col no-left-pad">
          <strong class="section-header">Policy coverages overview</strong>
        </div>
      </div>
    </div>
    <nwx-coverages-table
      [coverages]="getCoveragesForPolicyTable()"
      [termMonths]="termMonths"
    ></nwx-coverages-table>
    <hr />
    @for (vehicle of vehicles; track vehicle.vehicleId; let i = $index) {
      <div>
        <div class="info-row heading">
          <div class="bolt-row bolt-justify-content-between">
            <div class="bolt-col-xs-xs-6">
              <strong class="section-header"
                >{{ vehicle.year }} {{ vehicle.make || '' | titlecase }}
                {{ vehicle.model || '' | titlecase }}
              </strong>
            </div>
          </div>
        </div>
        <div class="info-row">
          <div class="bolt-row bolt-justify-content-between coverage-row">
            @if (
              getTelematicsEnrollmentById(vehicle.vehicleId) === 'SmartMiles') {
              <div
                class="bolt-col-xs-6 no-left-pad"
                >
                Variable premium est.
                <bolt-contextual-help>
                  <p>
                    Monthly estimated premium is subject to change based on
                    telematics.
                  </p>
                </bolt-contextual-help>
              </div>
            } @else {
              <div class="bolt-col-xs-6 no-left-pad">
                Premium est.
                <bolt-contextual-help>
                  <p>
                    Monthly vehicle premium is subject to change based on rating
                    tasks.
                  </p>
                </bolt-contextual-help>
              </div>
            }
            <div class="bolt-col-xs-6">
              <strong
                >{{
                getVehiclePremiumById(vehicle.vehicleId) | currency
                }}/mo</strong
                >
              </div>
            </div>
          </div>
          <nwx-coverages-table
            [coverages]="getCoveragesForVehicleTable(vehicle.vehicleId)"
            [termMonths]="termMonths"
          ></nwx-coverages-table>
          @if (vehicle.vehicleType === 'auto') {
            <div class="telematics-row">
              @if (enrollment) {
                <div class="bolt-row bolt-justify-content-between">
                  @if (
                    getTelematicsEnrollmentById(vehicle.vehicleId); as programType
                    ) {
                    <div
                      class="bolt-col-xs"
                      >
                      <!-- TELEMATICS ENROLLMENT STATUS HERE -->
                      <span [class]="programType" class="telematics-badge">
                        <div>
                          <strong
                            >{{
                            programType === 'SmartRideInstant'
                            ? 'SmartRide Instant'
                            : programType
                            }}®</strong
                            >
                            | Telematics
                          </div>
                          <div class="spacer"></div>
                          <span class="enrollment-inliner">
                            <div class="enrollment" (click)="emitEditTelematics()">
                              @if (
                                getTelematicsEnrollmentById(vehicle.vehicleId)) {
                                <span
                                  class="enrollment-text"
                                  [attr.id]="'acdc-enrolled-' + i"
                                  >Enrolled
                                </span>
                              } @else {
                                <span
                                  class="enrollment-text"
                                  [attr.id]="'acdc-not-enrolled-' + i"
                                  >Not Enrolled
                                </span>
                              }
                              <bolt-icon
                                class="enrollment-text"
                                name="pencil"
                                attr.id="acdc-edit-{{ i }}"
                                color="mediumBlue"
                                [attr.size]="maxSizeMini ? 'sm' : 'md'"
                              ></bolt-icon>
                            </div>
                          </span>
                        </span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
        <hr />
      } @else {
        <div class="coverages-footer pb-20" id="acdc-premiumSubstitute">
          <nwx-notification-bubble type="info">
            <p style="font-size: large; font-weight: 500">Review your rating tasks</p>
            <p>
              The rate isn’t available, because there may be unfinished tasks or
              errors. If you see any errors, request UW approval.
            </p>
            <div class="d-flex flex-column bolt-justify-content-between">
              <bolt-button
                color="mediumBlue"
                type="outline"
                class="button-float"
                size="md"
                (click)="scrollToTasks()"
                >Review rating tasks</bolt-button
                >
              </div>
            </nwx-notification-bubble>
          </div>
          <hr />
          <div class="details-container-last"></div>
        }

        <div class="button-container">
          <div class="bolt-row">
            <div class="bolt-col buttons-row">
              <div>
                <a
                  href="javascript:0"
                  (click)="editCoverages($event)"
                  class="vertical-align"
                  >
                  <div>Edit all coverages</div>
                  <bolt-icon name="pencil" class="edit-coverages-icon"></bolt-icon>
                </a>
              </div>
              <div>
                <bolt-button
                  type="solid"
                  [attr.id]="'acdc-view-edit-coverage'"
                  (click)="openCoveragesModal()"
                  >View all coverages</bolt-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

